import React from "react";
import { Alert, AlertDescription, AlertTitle } from "ui/components/alert";
import { Icon } from "components";
import { INFO } from "icons";

const format = (value) => Number(value.toFixed(2));



// Warning banner shown only while the allocation total is below 100%.
export default function AllocationTotalBanner({ total }) {
  if (total == null || total >= 100) {
    return null;
  }

  const title = `Allocation total: ${format(total)}%`;

  return (
    <Alert className="border-amber-300 bg-amber-50 text-amber-800">
      <Icon icon={INFO} />
      <AlertTitle>{title}</AlertTitle>
    </Alert>
  );
}